export default __webpack_public_path__ + "static/media/presewn.5cb37e0e.jpg";